import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { navigate } from 'gatsby'

import useFeatures from '../../../hooks/useFeatures'
import storageService from '../../../services/storageService'
import { AuthContext } from '../../../context/authProvider'

import icon_nav_deposit from '../../../images/icon_nav_deposit.svg'
import icon_nav_withdraw from '../../../images/icon_nav_withdraw.svg'
import icon_nav_vault2 from '../../../images/cashback/icon_navigation_cashback_B&W.svg'
import icon_nav_logout from '../../../images/icon_nav_logout.svg'
import icon_mybets from '../../../images/icon_mybets.svg'
import icon_nav_account from '../../../images/icon_nav_account.svg'
import icon_nav_oldbets from '../../../images/icon_nav_oldbets_new.svg'
import icon_nav_bonus from '../../../images/icon_nav_bonus.svg'
import refer_a_friend from '../../../images/refer-a-friend/icon_dropdownmenu_refer-a-friend.svg'
import icon_navigation_club from '../../../images/icon_navigation_club.svg'

import { FormatAmount } from '../../atoms/formatAmount'
import { If } from '../../atoms/if'
import { Tag } from '../../atoms/tag'
import {
  StyledCashbackAmount,
  StyledIcon,
  StyledRow,
  StyledWrapper,
  TagWrapper,
} from './styles'
import { useTranslation } from '../../../context/translationProvider'
import { useSportsbookSlugs } from '../../../hooks/useSportsbookSlugs'
import { useGroowthbookLocaleFeature } from '../../../hooks/useGrowthbook'
import { useFeatureValue } from '@growthbook/growthbook-react'
import { useIsReferAFriendEnabled } from '../../../hooks/useReferAFriend'
import { useEventTracking } from '../../../context/eventTrackingProvider'

const UserBalanceDropdownMenu = (props) => {
  const { translate } = useTranslation()
  const {
    cashbackCta,
    openDeposit,
    openWithdraw,
    profileSlug,
    referAFriendSlug,
    setToggleSubMenu,
  } = props
  const user = storageService.getUser()

  const { logoutUser, vaultAmount } = useContext(AuthContext)
  const isCashbackEnabled = useFeatures('cashback')
  const isOldBetsEnabled = useGroowthbookLocaleFeature('fe_igp_old_bets')
  const isSportsEnabled = useGroowthbookLocaleFeature('fe_igp_sports_enabled')
  const isGamificationEnabled = useFeatureValue('fe_igp_gamification')
  const isReferAFriendEnabled = useIsReferAFriendEnabled()
  const myBetsSlug = useSportsbookSlugs('my-bets')
  const bonusSlug = useSportsbookSlugs('bonus')
  const { trackEvent, EVENT_NAMES } = useEventTracking()

  const logout = async () => {
    logoutUser()
    navigate('/')
  }

  const handleOpenDrawer = (type) => {
    if (type === 'deposit') openDeposit()
    if (type === 'withdraw') openWithdraw()
    setToggleSubMenu(false)
  }

  return (
    <StyledWrapper>
      <If
        condition={isCashbackEnabled}
        render={() => (
          <StyledCashbackAmount>
            <span>{translate('navigation.vault')}</span>
            <br />
            <span className="amount">
              <FormatAmount
                amount={vaultAmount}
                shortCode={user.wallet.currency.short_code}
                currencySymbol={user?.wallet?.currency?.symbol}
              />
            </span>
          </StyledCashbackAmount>
        )}
      />
      <StyledRow
        onClick={() => handleOpenDrawer('deposit')}
        id="dropdown-menu-deposit"
      >
        <StyledIcon icon={icon_nav_deposit} />
        <span>{translate('navigation.deposit')}</span>
      </StyledRow>
      <StyledRow
        onClick={() => handleOpenDrawer('withdraw')}
        id="dropdown-menu-withdraw"
      >
        <StyledIcon icon={icon_nav_withdraw} />
        <span>{translate('navigation.withdraw')}</span>
      </StyledRow>
      <If
        condition={isReferAFriendEnabled}
        render={() => (
          <StyledRow
            onClick={() => navigate(`/${referAFriendSlug}/`)}
            id="dropdown-refer-a-friend"
            withTag
          >
            <StyledIcon icon={refer_a_friend} />
            <span>{translate('navigation.referAFriend')}</span>
            <TagWrapper>
              <Tag
                theme="secondary"
                fontWeight={600}
                fontSize="14px"
                text={translate('common.new')}
              />
            </TagWrapper>
          </StyledRow>
        )}
      />
      <If
        condition={isSportsEnabled}
        render={() => (
          <StyledRow
            onClick={() => navigate(myBetsSlug)}
            id="dropdown-menu-my-bets"
          >
            <StyledIcon icon={icon_mybets} />
            <span>{translate('navigation.myBets')}</span>
          </StyledRow>
        )}
      />
      <If
        condition={isSportsEnabled}
        render={() => (
          <StyledRow
            onClick={() => navigate(bonusSlug)}
            id="dropdown-menu-bonus"
          >
            <StyledIcon icon={icon_nav_bonus} />
            <span>{translate('navigation.sportsBonus')}</span>
          </StyledRow>
        )}
      />
      <If
        condition={isOldBetsEnabled}
        render={() => (
          <StyledRow
            onClick={() => navigate('/old-bets/')}
            id="dropdown-menu-old-bets"
          >
            <StyledIcon icon={icon_nav_oldbets} />
            <span>{translate('navigation.oldBets')}</span>
          </StyledRow>
        )}
      />
      <If
        condition={isGamificationEnabled}
        render={() => (
          <StyledRow
            onClick={() => {
              trackEvent(EVENT_NAMES.CLUBE_KTO_ENTRY_POINT_DROP_DOWN_MENU, {}, true)
              navigate(`/clube-kto/`)
            }}
            id="dropdown-clube-kto"
            withTag
          >
            <StyledIcon icon={icon_navigation_club} />
            <span>{translate('navigation.ktoClub')}</span>
            <TagWrapper>
              <Tag
                theme="secondary"
                fontWeight={600}
                fontSize="14px"
                text={translate('common.new')}
              />
            </TagWrapper>
          </StyledRow>
        )}
      />
      <If
        condition={isCashbackEnabled}
        render={() => (
          <StyledRow
            onClick={() => navigate(`${cashbackCta?.link?.url}`)}
            id="dropdown-menu-vault"
          >
            <StyledIcon icon={icon_nav_vault2} />
            <span>{translate('navigation.vault')}</span>
          </StyledRow>
        )}
      />
      <StyledRow
        onClick={() => navigate(`/${profileSlug}/`)}
        id="dropdown-menu-profile"
      >
        <StyledIcon icon={icon_nav_account} />
        <span>{translate('navigation.account')}</span>
      </StyledRow>
      <StyledRow onClick={logout} id="dropdown-menu-logout">
        <StyledIcon icon={icon_nav_logout} />
        <span>{translate('navigation.logout')}</span>
      </StyledRow>
    </StyledWrapper>
  )
}

UserBalanceDropdownMenu.defaultProps = {
  cashbackCta: {},
  openDeposit: () => {},
  openWithdraw: () => {},
  profileSlug: '',
  referAFriendSlug: '',
  setToggleSubMenu: () => {},
}

UserBalanceDropdownMenu.propTypes = {
  cashbackCta: PropTypes.object,
  openDeposit: PropTypes.func,
  openWithdraw: PropTypes.func,
  profileSlug: PropTypes.string,
  referAFriendSlug: PropTypes.string,
  setToggleSubMenu: PropTypes.func,
}

export { UserBalanceDropdownMenu }
